Namespace 'Monitoring.Views.SocialContents.Filters'

class Monitoring.Views.SocialContents.Filters.TextFilterView extends Backbone.View
  template: JST['backbone/templates/monitoring/filters/text_filter']
  className: 'filter user collapsed'

  events:
    'click #apply-user': 'filter'

  initialize: ({searchQuery, title}) ->
    @searchQuery = searchQuery
    @title = title
    @label = ''

  destroy: ->
    @remove()
    false

  render: =>
    @$el.html(
      @template(
        searchQuery: @searchQuery
        label: @label
        title: @title
      )
    )
    @

  filter: (event) =>
    values = _.map(@$el.find('#user').val().split(','), (value) -> value.trim())
    _.each(values, (value) => @_addValue(value))
    @_triggerQueryChanged()

  _addValue: (value) =>
    @searchQuery.addText(value)

  _triggerQueryChanged: =>
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)
